// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__175Or","nav":"Header_nav__1mDv7","sign":"Header_sign__3pmt3"};